var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col pb-16", attrs: { "data-id": _vm.panelId } },
    [
      _c(
        "div",
        {
          staticClass: "sticky top-0 z-10 flex flex-col bg-pure-white",
          attrs: { "data-id": _vm.panelId }
        },
        [
          _c(
            "div",
            {
              staticClass: "flex flex-col gap-2 px-6 py-6",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex items-center justify-between gap-4",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlTextTitle4", {
                    attrs: { "data-id": _vm.panelId, text: "Available credits" }
                  }),
                  _vm._v(" "),
                  _c("BlIcon", { attrs: { icon: "close", clickable: true } })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex flex-wrap gap-2 px-6",
              attrs: { "data-id": _vm.panelId }
            },
            _vm._l(_vm.itemOptions, function(item) {
              return _c(
                "div",
                {
                  key: item.value,
                  staticClass: "px-2 py-1 rounded-full cursor-pointer",
                  class: [
                    _vm.selectedId === item.value
                      ? "bg-light-purple-400"
                      : "bg-slate-200 hover:bg-slate-400"
                  ],
                  attrs: { "data-id": _vm.panelId },
                  on: {
                    click: function($event) {
                      _vm.selectedId = item.value
                    }
                  }
                },
                [
                  _c("BlTextBody2", {
                    class: { "text-pure-white": _vm.selectedId === item.value },
                    attrs: { "data-id": _vm.panelId, text: item.label }
                  })
                ],
                1
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      !_vm.availableItems.length
        ? _c(
            "div",
            {
              staticClass: "grid px-16 h-128 place-items-center",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlTextBody1", {
                staticClass: "text-center",
                attrs: {
                  "data-id": _vm.panelId,
                  text:
                    "All active credits will appear here once you add credits to the client."
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selected
        ? _c(
            "div",
            {
              staticClass: "flex flex-col px-6",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-between gap-2 py-3 border-b border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlTextBody2", {
                    staticClass: "text-slate-700",
                    attrs: {
                      "data-id": _vm.panelId,
                      text: "Current scheduled sessions"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "text-slate-1000",
                    attrs: {
                      "data-id": _vm.panelId,
                      text: _vm.selected.scheduled_sessions + " session(s)"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-1 py-3 border-b border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center justify-between gap-2",
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-slate-700",
                        attrs: {
                          "data-id": _vm.panelId,
                          text: "Total available credits"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "text-slate-1000",
                        attrs: {
                          "data-id": _vm.panelId,
                          text:
                            _vm.selected.total_available_credits + " credit(s)"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.selected.credit_transactions, function(
                    transaction
                  ) {
                    return _c(
                      "div",
                      {
                        key: transaction.id,
                        staticClass:
                          "flex items-center justify-between gap-2 truncate",
                        attrs: { "data-id": _vm.panelId }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text: "ID " + transaction.credit_transaction_id
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "flex-shrink-0 text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text:
                              transaction.total_available_credits + " credit(s)"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-1 py-3 border-b border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center justify-between gap-2",
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-slate-700",
                        attrs: {
                          "data-id": _vm.panelId,
                          text: "Total reserved credits"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "text-slate-1000",
                        attrs: {
                          "data-id": _vm.panelId,
                          text:
                            _vm.selected.total_reserved_credits + " credit(s)"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.selected.credit_transactions, function(
                    transaction
                  ) {
                    return _c(
                      "div",
                      {
                        key: transaction.id,
                        staticClass:
                          "flex items-center justify-between gap-2 truncate",
                        attrs: { "data-id": _vm.panelId }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text: "ID " + transaction.credit_transaction_id
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "flex-shrink-0 text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text:
                              transaction.total_reserved_credits + " credit(s)"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-1 py-3 border-b border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center justify-between gap-2",
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-slate-700",
                        attrs: {
                          "data-id": _vm.panelId,
                          text: "Total unused credits"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "text-slate-1000",
                        attrs: {
                          "data-id": _vm.panelId,
                          text: _vm.selected.total_unused_credits + " credit(s)"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.selected.credit_transactions, function(
                    transaction
                  ) {
                    return _c(
                      "div",
                      {
                        key: transaction.id,
                        staticClass:
                          "flex items-center justify-between gap-2 truncate",
                        attrs: { "data-id": _vm.panelId }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text: "ID " + transaction.credit_transaction_id
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "flex-shrink-0 text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text:
                              transaction.total_unused_credits + " credit(s)"
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-1 py-3 border-b border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center justify-between gap-2",
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-slate-700",
                        attrs: {
                          "data-id": _vm.panelId,
                          text: "Current balance"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { "data-id": _vm.panelId } },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-1000",
                            attrs: {
                              "data-id": _vm.panelId,
                              text: _vm.currentCenter.currency_sym
                            }
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "text-slate-1000",
                            attrs: {
                              "data-id": _vm.panelId,
                              text: _vm.priceFormats(
                                _vm.selected.current_balance
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.selected.credit_transactions, function(
                    transaction
                  ) {
                    return _c(
                      "div",
                      {
                        key: transaction.id,
                        staticClass:
                          "flex items-center justify-between gap-2 truncate",
                        attrs: { "data-id": _vm.panelId }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text: "ID " + transaction.credit_transaction_id
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { "data-id": _vm.panelId } },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-slate-700",
                              attrs: {
                                "data-id": _vm.panelId,
                                text: _vm.currentCenter.currency_sym
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "flex-shrink-0 text-slate-700",
                              attrs: {
                                "data-id": _vm.panelId,
                                text: _vm.priceFormats(
                                  transaction.current_balance
                                )
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-1 py-3 border-b border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex items-center gap-2",
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-slate-700",
                        attrs: {
                          "data-id": _vm.panelId,
                          text: "Expiration date"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "BlTooltip",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "tooltip",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-col w-40 gap-1 text-center"
                                      },
                                      [
                                        _vm._v(
                                          "\n              The expiration date is the deadline to use credits for booking;\n              once booked, they stay valid even if the appointment occurs\n              later.\n            "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            2154906160
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass: "w-4 h-4",
                            attrs: { icon: "info" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.selected.credit_transactions, function(
                    transaction
                  ) {
                    return _c(
                      "div",
                      {
                        key: transaction.id,
                        staticClass:
                          "flex items-center justify-between gap-2 truncate",
                        attrs: { "data-id": _vm.panelId }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text: "ID " + transaction.credit_transaction_id
                          }
                        }),
                        _vm._v(" "),
                        transaction.expiration_date === null
                          ? _c("BlTextBody2", {
                              staticClass: "text-slate-1000",
                              attrs: {
                                "data-id": _vm.panelId,
                                text: "No expiration date"
                              }
                            })
                          : _c("BlTextBody2", {
                              staticClass: "text-slate-1000",
                              attrs: {
                                "data-id": _vm.panelId,
                                text: _vm.displayDate({
                                  date: transaction.expiration_date,
                                  format: "DD MMMM YYYY"
                                })
                              }
                            })
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-1 py-3 border-b border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlTextBody2", {
                    staticClass: "text-slate-700",
                    attrs: { "data-id": _vm.panelId, text: "Date created" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.selected.credit_transactions, function(
                    transaction
                  ) {
                    return _c(
                      "div",
                      {
                        key: transaction.id,
                        staticClass:
                          "flex items-center justify-between gap-2 truncate",
                        attrs: { "data-id": _vm.panelId }
                      },
                      [
                        _c("BlTextBody2", {
                          staticClass: "truncate text-slate-700",
                          attrs: {
                            "data-id": _vm.panelId,
                            text: "ID " + transaction.credit_transaction_id
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-slate-1000",
                          attrs: {
                            "data-id": _vm.panelId,
                            text: _vm.displayDate({
                              date: transaction.created_at,
                              format: "DD MMMM YYYY"
                            })
                          }
                        })
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-867a6afc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-867a6afc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/creditTransaction/AvailableCreditsPanel.vue
// module id = null
// module chunks = 